// @ts-nocheck
import React from "react";
import styled from "@emotion/styled";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import InputSlider from "react-input-slider";
import moment from "moment";

import { injectIntl } from "react-intl";

import CommonUtils from "services/common/utils";
import ParkkiTheme from "themes/ParkkiTheme";
import TextField from "components/TextField";

const InputContainer = styled.div`
  cursor: pointer;
  width: 100%;
`;

const DialogTitle = styled.div`
  margin-bottom: 16px;
  color: ${ParkkiTheme.colors.turquoise};
`;

const TimeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #ffffff;
  width: 380px;
  padding: ${ParkkiTheme.spacings.base};
`;

const ShowTime = styled.div`
  text-align: center;
`;

const Time = styled.span`
  width: 65px;
  height: 65px;
  display: inline-block;
  font-size: 38px;
  line-height: 65px;
  background-color: ${ParkkiTheme.colors.turquoise};
  border-radius: 3px;
  text-align: center;
`;

const Separator = styled.span`
  display: inline-block;
  font-size: 32px;
  font-weight: bold;
  color: ${ParkkiTheme.colors.turquoise};
  width: 32px;
  height: 65px;
  line-height: 65px;
  text-align: center;
`;

const TimeText = styled.div`
  position: relative;
  left: -10px;
  font-size: 15px;
  color: ${ParkkiTheme.colors.turquoise};
  margin-top: 7px;
  margin-bottom: 10px;
`;

const StyledTextField = styled(TextField)`
  & > input {
    cursor: pointer !important;
  }
`;

class TimeSlider extends React.PureComponent {
  state = {
    duration: 600,
  };

  componentDidMount = () => {
    this.setState({
      duration: this.props.duration,
    });
  };

  componentDidUpdate = (prevProps) => {
    if (prevProps.duration !== this.props.duration) {
      this.setState({
        duration: this.props.duration,
      });
    }
  };

  changeHours = (pos) => {
    const diff = moment.duration(this.state.duration * 1000);
    const newDuration =
      diff.days() * 86400 + pos.x * 3600 + diff.minutes() * 60;
    this.setState({ duration: newDuration });
  };

  changeMinutes = (pos) => {
    const { duration } = this.state;
    const diff = moment.duration(duration * 1000);
    const newDuration = diff.days() * 86400 + diff.hours() * 3600 + pos.x * 60;
    this.setState({ duration: newDuration });
  };

  changeDays = (pos) => {
    const { duration } = this.state;
    const diff = moment.duration(duration * 1000);
    const newDuration =
      pos.x * 86400 + diff.hours() * 3600 + diff.minutes() * 60;
    this.setState({ duration: newDuration });
  };

  renderSliders() {
    const { intl } = this.props;
    const { duration } = this.state;
    const { days, hours, minutes } =
      CommonUtils.splitDateFromDuration(duration);

    return (
      <TimeContainer>
        <DialogTitle>{this.props.title}</DialogTitle>
        <ShowTime>
          <Time>{days}</Time>
          <Separator>{intl.messages["components.timeSlider.day"]}</Separator>
          <Time>{hours}</Time>
          <Separator>{intl.messages["components.timeSlider.hour"]}</Separator>
          <Time>{minutes}</Time>
          <Separator>{intl.messages["components.timeSlider.minute"]}</Separator>
        </ShowTime>

        <div>
          <TimeText>{intl.messages["components.timeSlider.days"]}</TimeText>
          <InputSlider
            styles={{
              active: {
                backgroundColor: ParkkiTheme.colors.turquoise,
              },
            }}
            className="u-slider-time"
            xmin={this.props.days.xmin}
            xmax={this.props.days.xmax}
            xstep={this.props.daysStep}
            x={days}
            onChange={this.changeDays}
          />

          <TimeText>{intl.messages["components.timeSlider.hours"]}</TimeText>
          <InputSlider
            styles={{
              active: {
                backgroundColor: ParkkiTheme.colors.turquoise,
              },
            }}
            xmin={0}
            xmax={23}
            xstep={this.props.hourStep}
            x={hours}
            onChange={this.changeHours}
          />

          <TimeText>{intl.messages["components.timeSlider.minutes"]}</TimeText>
          <InputSlider
            styles={{
              active: {
                backgroundColor: ParkkiTheme.colors.turquoise,
              },
            }}
            className="u-slider-time"
            xmin={0}
            xmax={59}
            xstep={this.props.minStep}
            x={minutes}
            onChange={this.changeMinutes}
          />
        </div>
      </TimeContainer>
    );
  }

  saveDuration = () => {
    this.props.onSubmit(this.state.duration);
    this.props.hideDialog();
  };

  renderActions = () => {
    const { intl } = this.props;

    return (
      <DialogActions>
        <Button
          label={intl.messages["components.buttons.cancel"]}
          color="secondary"
          onClick={this.handleClose}
        >
          {intl.messages["components.buttons.cancel"]}
        </Button>
        <Button color="primary" onClick={this.saveDuration}>
          {intl.messages["components.buttons.ok"]}
        </Button>
      </DialogActions>
    );
  };

  handleClose = () => {
    this.props.hideDialog();
    this.setState({ duration: this.props.duration });
  };

  render() {
    const { intl, timeSliderDialogOpen } = this.props;

    return (
      <InputContainer>
        <StyledTextField
          disabled
          value={CommonUtils.humanizeDateFromDuration(
            this.props.duration,
            "seconds",
            this.props.intl
          )}
          onClick={this.props.showDialog}
          label={this.props.floatingLabel}
          onChange={() => {}}
          fullWidth={this.props.fullWidth}
          helperText={intl.messages["components.timeSlider.clickToChange"]}
        />
        <Dialog open={timeSliderDialogOpen} onClose={this.handleClose}>
          {this.renderSliders()}
          {this.renderActions()}
        </Dialog>
      </InputContainer>
    );
  }
}

TimeSlider.defaultProps = {
  daysStep: 1,
  days: { xmin: 0, xmax: 30 },
  duration: 600,
  fullWidth: false,
  hourStep: 1,
  minStep: 1,
  onSubmit: () => {},
  title: "Time",
  floatingLabel: "Max time (minutes)",
};

export default injectIntl(TimeSlider);
